export default __webpack_public_path__ + "static/media/london.a0d16668.jpg";